import React from 'react';
import ReturnsIcon from '@moda/icons/returns-20';
import { Stack, Text } from '@moda/om';
import { BehindFeatureFlag } from '@moda/portal-stanchions';
import { useCartItems } from '../../hooks/useCart';
import { usePreferences } from '../../hooks/usePreferences';
import { ReturnPolicyHyperlink } from '../ReturnPolicyInformation';
import { pluralize } from './pluralize';
import { ShoppingBagNotification } from './ShoppingBagNotification';

export const ReturnPolicyNotification: React.FC = () => {
  const { returnPolicyChangedItems } = useCartItems();
  const { returnPolicyChangeNotifications, setPreference } = usePreferences();

  if (returnPolicyChangedItems.length === 0) return null;
  if (!returnPolicyChangeNotifications) return null;

  return (
    <BehindFeatureFlag
      flagName="link_promo_with_returns"
      showWhenValueIs={true}
      showIfFlagIsUnavailable
    >
      <ShoppingBagNotification
        color="code-red"
        title="Return Policy Update"
        onClose={() => setPreference('returnPolicyChangeNotifications', false)}
      >
        <Stack space={4}>
          <Text>
            Based on applied promo code, the return policy for {returnPolicyChangedItems.length}{' '}
            {pluralize('item', returnPolicyChangedItems.length)} has been updated:
          </Text>
          <Stack space={2}>
            <Stack space={2} direction="horizontal">
              <ReturnsIcon />
              <Text treatment="bold1">Updated Return Policy</Text>
            </Stack>
            <Text>
              This item is returnable for a full refund within{' '}
              <Text treatment="bold1">14 days</Text> from the date that the order was delivered to
              you.
            </Text>
            <div>
              <ReturnPolicyHyperlink>Learn more</ReturnPolicyHyperlink>
            </div>
          </Stack>
        </Stack>
      </ShoppingBagNotification>
    </BehindFeatureFlag>
  );
};
